import React, {useState} from "react";
import DialogPDP from "../../products/ProductPage/DialogPDP";
import {t} from "../../../shared-services/translate";
import AdjustmentListItem from "../Adjustments/AdjustmentListItem";

const CartSidebarAdjustments = (props) => {
  const {currentCart, className = "", style} = props;
  const [showDialog, setShowDialog] = useState("");

  const hasAdditionalInfo = (adjustment) => !!Object.keys(adjustment?.additional_info || {}).length;

  const handleClick = (adjustment) => {
    if (adjustment.additional_info) {
      if (!Object.keys(adjustment.additional_info).length) return;

      setShowDialog(adjustment.code === showDialog ? "" : adjustment.code);
    }
  };

  return <div className={className} style={style}>
    {currentCart?.cart_summary?.adjustments.map(adjustment => {
      return <div key={adjustment?.label} className="position-relative font-size-body-smaller">
        {hasAdditionalInfo(adjustment) &&
          <DialogPDP
            show={showDialog === adjustment.code}
            position="bottom"
            onClose={() => handleClick(adjustment)}
          >
            {adjustment.additional_info.title.length > 0
              ? <div className="font-size-body margin-bottom-10">
                {t(adjustment.additional_info.title)}
              </div>
              : null
            }
            {adjustment.additional_info.body?.length > 0
              ? <div>{t(adjustment.additional_info.body)}</div>
              : null
            }
          </DialogPDP>
        }

        <AdjustmentListItem
          key={adjustment.label}
          adjustment={adjustment}
          mov={currentCart?.item_total >= currentCart?.minimum_order_value ? null : currentCart.minimum_order_value}
          onClick={() => handleClick(adjustment)}
          className="position-relative font-size-body-smaller"
        />
      </div>;
    })}
  </div>;
};

export default CartSidebarAdjustments;
